/*!
* global/window.js
* https://github.com/RobinHerbots/Inputmask
* Copyright (c) 2010 - 2017 Robin Herbots
* Licensed under the MIT license (http://www.opensource.org/licenses/mit-license.php)
* Version: 3.3.11
*/

"function" == typeof define && define.amd ? define(function() {
    return window;
}) : "object" == typeof exports && (module.exports = window);


//////////////////
// WEBPACK FOOTER
// ./~/inputmask/dist/inputmask/global/window.js
// module id = 43
// module chunks = 38